import {Config} from '../Model/Environment/Config';

export const configTest: Config = {
  serverUrl: '',
  publicKey: '',
};
